(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-catalog"] && !Shopify.designMode) return;
  try {
    // Make entire product card clickable while preserving interactive elements
document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('.product-card').forEach(function(card) {
    var link = card.querySelector('.product-title a');
    if (!link) return;
    var url = link.getAttribute('href');
    card.addEventListener('click', function(e) {
      if (e.target.closest('a, button, .product-review-trigger, .product-rating, [role="button"], input, label')) return;
      window.location.href = url;
    });
  });
});

// Sort product grid: available first, then by stock quantity descending
document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('.product-grid').forEach(function(grid) {
    var cards = Array.from(grid.querySelectorAll('.product-card'));
    cards.sort(function(a, b) {
      var aAvail = a.dataset.available === 'true' ? 1 : 0;
      var bAvail = b.dataset.available === 'true' ? 1 : 0;
      if (aAvail !== bAvail) return bAvail - aAvail;
      return parseInt(b.dataset.inventory || 0) - parseInt(a.dataset.inventory || 0);
    });
    cards.forEach(function(card) { grid.appendChild(card); });
  });
});

// Función global para agregar al carrito - usa la función reutilizable del modal
if (!window.addToCart) {
  window.addToCart = function(variantId, quantity, button) {
    // Leer recomendaciones del data attribute del botón
    var recommendations = null;
    if (button && button.dataset && button.dataset.recommendations) {
      recommendations = button.dataset.recommendations.split(',').filter(Boolean);
    }

    // Verificar que la función reutilizable esté disponible
    if (typeof window.addProductToCartWithModal === 'function') {
      return window.addProductToCartWithModal(variantId, quantity, button, recommendations);
    } else {
      // console.error('addProductToCartWithModal function not found. Make sure add-to-cart-modal.liquid is loaded.');
      window.showErrorToast && window.showErrorToast('El sistema de carrito no está disponible. Por favor recarga la página.');
    }
  };
}
  } catch(e) { console.error(e); }
})();

})();
